module.exports = __webpack_public_path__ + "img/zhengmian.4bb1f158.png";